import React, { useContext } from 'react'
import { getMetricsPublisherAsync, publishCounter, publishString } from '@amzn/aapn-front-end-metrics'
import { ErrorBoundary, ErrorPage } from '@amzn/aapn-react-components'
import { useTranslation } from 'react-i18next'
import { CrowdSurfConfig, CrowdSurfConfigContext } from '../../../util/appconfig'

type GlobalErrorBoundaryProps = React.PropsWithChildren<{}>

export const GlobalErrorBoundaryPage: React.FunctionComponent = (): JSX.Element => {
  const { t } = useTranslation()
  const config = useContext<CrowdSurfConfig>(CrowdSurfConfigContext)

  return (
    <ErrorPage
      location={{
        state: {
          title: t('GLOBAL_ERROR:TITLE'),
          message: t('GLOBAL_ERROR:MESSAGE'),
          routeDisplayText: t('GLOBAL_ERROR:DISPLAY_TEXT'),
          routePath: `${config.hostname}/partners/directory`,
        },
      }}
    />
  )
}

export const GlobalErrorBoundary: React.FunctionComponent<GlobalErrorBoundaryProps> = (props: GlobalErrorBoundaryProps): JSX.Element => {
  return (
    <ErrorBoundary
      onCatchError={(error: Error) => {
        getMetricsPublisherAsync('GlobalErrorBoundary').then(p => {
          publishCounter('errorName.all', 1)(p)
          publishCounter(`errorName.${error.name}`, 1)(p)
          publishString('global_error_boundary', `${error.name}`)(p)
        })
      }}
      onRenderError={<GlobalErrorBoundaryPage />}
    >
      {props.children}
    </ErrorBoundary>
  )
}
